<template>
  <div>
    <b-table :data="shows" :bordered="false" :striped="true" :hoverable="true">
      <template slot-scope="props">

        <b-table-column field="date" label="Date">{{ props.row.dateString }}</b-table-column>

        <b-table-column field="name" label="Name">
          <b>{{ props.row.name }}</b>
        </b-table-column>

        <b-table-column field="bands" label="Bands" centered>
          <p v-for="band in props.row.bands" :key="band.ID">{{band.name}}</p>
        </b-table-column>

        <b-table-column label="Edit">
          <button class="button is-small ">
            <b-icon pack="fas" :icon="'edit'" @click.native="editEvent(props.row)"></b-icon>
          </button>
        </b-table-column>

        <b-table-column label="Delete">
          <button class="button is-small is-danger">
            <b-icon pack="fas" :icon="'trash'" type="is-light" @click.native="editVenue(props.row)"></b-icon>
          </button>
        </b-table-column>
      </template>
    </b-table>
    <b-field grouped position="is-right">
      <p class="control addButton">
        <button class="button is-primary" @click="newEvent">Add new show</button>
      </p>
    </b-field>
    <b-modal :active.sync="isNewEventDialog" has-modal-card @close="getEvents">
      <CreateEvent :event="selectedEvent"></CreateEvent>
    </b-modal>
  </div>
</template>

<script>
import BModal from "buefy/src/components/modal/Modal";
import CreateEvent from "./CreateEvent";

export default {
  name: "Shows",
  components: { CreateEvent, BModal },
  data() {
    return {
      shows: [],
      isNewEventDialog: false,
      selectedEvent: {}
    };
  },
  methods: {
    editEvent: function(event) {
      this.selectedEvent = event;
      this.isNewEventDialog = true;
    },
    newEvent: function() {
      this.selectedEvent = {};
      this.isNewEventDialog = true;
    },
    getEvents: function() {
      this.$store
        .dispatch("getEvents")
        .then(() => (this.shows = this.$store.getters.events))
        .catch(err => console.log(err));
    }
  },
  mounted() {
    this.getEvents();
  }
};
</script>

<style scoped>
.ddialog {
  min-width: 400px;
}


</style>
